module.exports = __webpack_public_path__ + "img/fsttit.2d75070b.png";